<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
        class="table-style"
        stripe
        highlight-hover-row
        show-footer
        show-overflow
        max-height="500"
        border="none"
        :loading="loading"
        :data="invoiceListData"
        :auto-resize="true"
        align="center"
        :footer-method="footerMethod"
        @filter-change="filterTypeMethod"
        @cell-click="cellClick"
        ref="xTable"
        resizable
    >
      <vxe-table-column type="seq" title="序号" width="60">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{ $rowIndex + 1 }}</span>
<!--          <Dropdown trigger="click" style="margin-left: 20px" transfer>-->
<!--            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>-->
<!--            <DropdownMenu slot="list" style="left: 70px">-->
<!--              <div style="display: flex; flex-direction: column">-->
<!--                <Button class="button-gengduo" @click="confirmEvent(row.id)"-->
<!--                        v-if="isHavePermission('invoice2.0:removeInvoiceSeller')">移除销项发票-->
<!--                </Button>-->
<!--              </div>-->
<!--            </DropdownMenu>-->
<!--          </Dropdown>-->
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="invoiceNum"
          title="发票编号"
          width="120"
          class-name="link-text"
      ></vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" min-width="130" v-if="isHavePermission('invoice2.0:flowNumSeller')">
        <template slot-scope="{ row }">
            <span
                @click="openProcedureDetailTwo(row.flowId, 2)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
            >
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="addTime"
          title="开票日期"
          min-width="100"
      ></vxe-table-column>
      <vxe-table-column
          field="invoiceType"
          title="发票类型"
          min-width="120"
      ></vxe-table-column>
      <vxe-table-column
          field="invoiceCompName"
          title="开票企业名称"
          min-width="180"
          :filters="filterInvoiceCompName"
      ></vxe-table-column>
      <vxe-table-column
          field="invoiceTitle"
          title="发票抬头"
          min-width="200"
          :filters="filterInvoiceTitle"
      ></vxe-table-column>
      <vxe-table-column
          field="goodsName"
          title="应税商品名称"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column
          field="counts"
          title="数量"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column field="unit" title="单位" min-width="70"></vxe-table-column>
      <vxe-table-column field="price" title="单价" min-width="90">
        <template slot-scope="{ row }">
          <span>{{ row.price | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="taxRate"
          title="税率（%）"
          width="100"
      ></vxe-table-column>
      <vxe-table-column field="taxAmount" title="税额（元）" min-width="150">
        <template slot-scope="{ row }">
          <span>{{ row.taxAmount | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="taxTotalAmount" title="价税合计（元）" min-width="180">
        <template slot-scope="{ row }">
          <span>{{ row.taxTotalAmount | numberToCurrency }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="carShipNum"
          title="车船号"
          min-width="100"
      ></vxe-table-column>
      <vxe-table-column
          field="beginPlace"
          title="起运地"
          min-width="100"
      ></vxe-table-column>
      <vxe-table-column
          field="endPlace"
          title="目的地"
          min-width="100"
      ></vxe-table-column>
      <vxe-table-column
          field="laydays"
          title="起运日期"
          min-width="150"
      ></vxe-table-column>
      <vxe-table-column
          field="note"
          title="备注信息"
          min-width="100"
      ></vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="handlePageChange"
    ></vxe-pager>

    <vxe-modal
        v-model="isShowInvoiceDetail"
        title="发票详情"
        width="1200"
        height="920"
        position="center"
        resize
        remember
    >
      <detail ref="detail" :cate="'Sales'" @close="isShowInvoiceDetail = false" @init="init"></detail>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {timeFormatDate} from "@/filters/time";
  import {invoiceMap, numberToCurrency} from "@/filters/type";
  import Detail from "@/components/order2.0/Invoice/Detail";
  import {invoiceFooter, getFilterObj} from "@/utils/util";
  import openProcedureDetailTwo from "@/mixin/viewOrderDetail";
  import getAuthOrization from "@/mixin/getAuthOrization";

  // 销项发票
  export default {
    components: {
      Detail,
    },
    props: ['id', 'pageTab'],
    mixins: [openProcedureDetailTwo,getAuthOrization],
    data() {
      return {
        loading: false,
        invoiceListData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        invoiceCompName: null,
        invoiceTitle: null,
        countRtnVo: {},
        isShowInvoiceDetail: false,
        filterInvoiceCompName: [],
        filterInvoiceTitle: [],
      };
    },
    watch: {
      // id(nv, ov) {
      //   if (nv !== ov && nv !== undefined) {
      //     this.getInvoiceListData();
      //   }
      // },
      pageTab() {
        this.pageTab === 6 ? this.getInvoiceListData() : ''
      }
    },
    // activated() {
    //   // this.getInvoiceListData();
    //   this.$bus.$on("allOrderDetailRenovate", (data) => {
    //     data === true ? this.getInvoiceListData() : "";
    //   });
    // },
    methods: {
      init() {
        this.getInvoiceListData();
      },
      filterTypeMethod({column, property, values, datas, filters, $event}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          if (property == "invoiceTitle") {
            this.invoiceTitle = values;
          } else if (property == "invoiceCompName") {
            this.invoiceCompName = values;
          }
        } else {
          this.invoiceTitle = null;
          this.invoiceCompName = null;
        }
        this.getInvoiceListDataFilter();
      },
      async getInvoiceListDataFilter() {
        this.loading = true;
        let res = await $api.invoiceTwo.request("queryInvoiceSellerListSelect", {
          ordersId: this.id,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          orderBy: 2,
          invoiceTitle: this.invoiceTitle,
          invoiceCompName: this.invoiceCompName,
          ordersVersion: 2
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.countRtnVo = res.data.countRtnVo;
          let invoiceListData = res.data.rows;
          this.invoiceListData = invoiceListData;
          invoiceListData.map((i) => {
            i.addTime = timeFormatDate(i.addTime);
            i.laydays = timeFormatDate(i.laydays);
            i.invoiceType = invoiceMap(i.invoiceType);
          });
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async getInvoiceListData() {
        this.filterInvoiceCompName = [];
        this.filterInvoiceTitle = [];
        this.loading = true;
        let res = await $api.invoiceTwo.request("queryInvoiceSellerListSelect", {
          ordersId: this.id,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          orderBy: 2,
          invoiceTitle: this.invoiceTitle,
          invoiceCompName: this.invoiceCompName,
          ordersVersion: 2
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.countRtnVo = res.data.countRtnVo;
          let invoiceListData = res.data.rows;
          const xTable = this.$refs.xTable;
          const invoiceCompNameColumn = xTable.getColumnByField(
            "invoiceCompName"
          );
          const invoiceTitleColumn = xTable.getColumnByField("invoiceTitle");
          // console.log(invoiceListData, "invoiceListData");
          invoiceListData.map((i) => {
            getFilterObj(this.filterInvoiceCompName, i.invoiceCompName);
            getFilterObj(this.filterInvoiceTitle, i.invoiceTitle);
            i.addTime = timeFormatDate(i.addTime);
            i.laydays = timeFormatDate(i.laydays);
            i.invoiceType = invoiceMap(i.invoiceType);
          });
          xTable.setFilter(invoiceCompNameColumn, this.filterInvoiceCompName);
          xTable.setFilter(invoiceTitleColumn, this.filterInvoiceTitle);
          xTable.updateData();
          this.invoiceListData = invoiceListData;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async confirmEvent(id) {
        let confirmRes = await this.$XModal.confirm(
          "删除后，将解除此订单关联的发票信息",
          "是否删除此发票？"
        );
        if (confirmRes === "confirm") {
          let res = await $api.invoiceTwo.request("removeInvoiceSeller", {
            id,
          });
          if (res.status === 1) {
            this.$XModal.message({message: `删除成功！`});
            this.getInvoiceListData();
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        }
      },
      handlePageChange({currentPage, pageSize}) {
        // 分页
        this.page.currentPage = currentPage;
        this.page.pageSize = pageSize;
        this.getInvoiceListDataFilter();
      },
      footerMethod({columns, data}) {
        return invoiceFooter({columns, data, countRtnVo: this.countRtnVo});
      },
      cellClick(e) {
        let field = e.column.property;
        if (field == "invoiceNum") {
          if (!this.isHavePermission('invoiceSeller2.0:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
          this.isShowInvoiceDetail = true;
          this.$refs.detail.setEdit(false);
          this.$refs.detail.init(e.row);
        }
      },
    },
  };
</script>

<style>
</style>